import React from 'react';
import styles from './index.css';
import { shadow } from '@src/constants/index';

const content = ({ goResult, item, length, index, id }) => {
    return (
        <div className={styles.contentItem}>
            <div
                className={styles.contenttitle}
                onClick={() => {
                    goResult(id);
                }}>
                {item?.title}
                {item?.isHot && <div className={styles.hot}>HOT</div>}
            </div>

            {length % 2 === 0 && (length - 1 !== index && length - 2 !== index) && <img src={shadow} className={styles.itemShadow} />}
            {length % 2 === 1 && length - 1 !== index && <img src={shadow} className={styles.itemShadow} />}
        </div>
    );
};

export default content;
